import React from 'react';

import CompanyTable from './CompanyTable';

export default () => <CompanyTable />;
